export default "__VITE_ASSET__GGrSt4ZG__"